import { Component, ComponentRef, ElementRef,EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CorrespondantService } from 'src/app/services/correspondant/correspondant.service';
import { IdCommunicationService } from 'src/app/services/node/id-communication.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { CorrespondantPatient } from 'src/app/utils/interfaces/new/correspondant-patient';
import { Correspondant } from 'src/app/utils/interfaces/new/correspondant.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Repertoire } from 'src/app/utils/interfaces/new/repertoire';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { FichePatient } from 'src/app/utils/interfaces/new/fiche-patient.interface';

@Component({
  selector: 'app-add-correspondant-in-editor',
  templateUrl: './add-correspondant-in-editor.component.html',
  styleUrls: ['./add-correspondant-in-editor.component.scss',
  '../modal.fragment.scss'
  ]
})
export class AddCorrespondantInEditorComponent implements OnInit {

  @ViewChild('modalBodyCor') public modalBody: ElementRef;
  @ViewChild('outsideModalCor') public outsideModal: ElementRef;

  public modalTitle: string = 'Ajout d\'un pavé correspondant';

  public patientId: string;
  public receiver: Subscription;

  accessible: boolean;

  @Output() correspondantsSelected = new EventEmitter<Correspondant[]>();
  @Output() public closeEmitter = new EventEmitter();
  @Output() public correspondantsUpdated = new EventEmitter<Correspondant[]>();
  @Input() public selectBodyTable: Paginated<Correspondant> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  };

  selectColumnTable = [
    { title: 'Correspondant(s) sélectionné(s)', data: 'nom' || 'nom complet' },
    { title: '', data: null }
  ];

  correspondantsCabinet: Correspondant[];
  correspondantsPatient: Correspondant[];
  untouchedCorrespondants: CorrespondantPatient[];
  untouchedContacts: Repertoire[];
  fichePatient: FichePatient;

  correspondantsBodyTable: Paginated<Correspondant> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  };
  correspondantsColumnTable = [
    { title: 'Recherche: Correspondants du cabinet', data: 'nom complet' },
    { title: '', data: null }
  ];

  correspondantsPatientBodyTable: Paginated<Correspondant> = {
    objects: [],
    page: 1,
    perpage: -1,
    total: 0
  };
  
  correspondantsPatientColumnTable = [
    { title: 'Correspondants du patient', data: 'nom complet' },
    { title: '', data: null }
  ];


  constructor(
    private _correspondant: CorrespondantService,
    private _strUtilsSrv: StringUtilsService,
    private _patient: PatientService,
    private _receive: IdCommunicationService,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _snakeBarSrv: SnackbarService,


    
  ) { }

  async ngOnInit(): Promise<void> {
    await new Promise<void>((resolve, _) => {
      if (!this.receiver) {
        this.receiver = this._receive.idAnnounced$.subscribe(
          async id => {
            if (id == "NOT_ACCESSIBLE") {
              this.accessible = false;
            } else {
              this.accessible = true;
              this.patientId = id;
            }
            resolve();
          });
        this._receive.confirmMission("ASK");
      }
    });
    await this.init();
  }

async init(){
//On stocke kes ids des correspondants du patient pour aller requêter leurs infos dans le back.
 let ids:string[] = [];

 await this.getPatientAddress();
  const repertoirePatient = await this._patient.findOnePatientRepertoire(this.patientId);

    this.untouchedCorrespondants = repertoirePatient.correspondants;

    for(let correspondant of  this.untouchedCorrespondants){
      ids.push(correspondant.idCorrespondant)
    }
    
    this.correspondantsPatient = await this._correspondant.find({
      perpage: 0,
      currentPage: 1,
      sortBy: 'nom',
      sortOrder: SortEnum.ASC
    }, ids);

    for (let cor of this.correspondantsPatient) {
      Object.defineProperty(cor, 'nom complet', { value: cor.nom +' '+ cor.prenom});
      this.correspondantsPatientBodyTable.objects.push(cor);
    
    }
       
    this.untouchedContacts = repertoirePatient.repertoires;
    for (let int of this.untouchedContacts) {
      Object.defineProperty(int, 'nom complet', { value: int.nom +' '+ int.prenom});
      this.correspondantsPatientBodyTable.objects.push(int);

    }
    
    //On trie par ordre alphabétique les correspondants ici, car ils viennent de 2 endpoints différents donc on ne peut pas les trier dans le back.
    this.correspondantsPatientBodyTable.objects.sort((a, b) => {
      const nomA = a['nom complet'].toLowerCase();
      const nomB = b['nom complet'].toLowerCase();
      if (nomA < nomB) {
        return -1;
      }
      if (nomA > nomB) {
        return 1;
      }
      return 0;
    });

}

private _loading: ComponentRef<LoadingModalFragment> | undefined = undefined;

private async _displayLoading(doDisplay: boolean): Promise<void> {
  if (doDisplay && !this._loading) {
    this._loading = this._modal.openLoading(this._view);
  } else if (!doDisplay && this._loading) {
    this._loading.destroy();
    this._loading = undefined;
  }
}

private async getPatientAddress(){
  let nom: string | undefined;
  let prenom: string | undefined;
  let adressePrincipale: string | undefined;
  let codePostal: string | undefined;
  let ville: string | undefined;

  this.fichePatient = await this._patient.findOnePatientFiche(this.patientId);
  
  if (this.fichePatient?.adresses && this.fichePatient?.adresses.length > 0) {
    const adresses = this.fichePatient.adresses;
    const adresseChoisie = adresses.length === 1
      ? adresses[0]
      : adresses.find(a => a.isPrincipale);
    if (adresseChoisie) {
      adressePrincipale = adresseChoisie.adresse;
      codePostal = adresseChoisie.codePostal;
      ville = adresseChoisie.ville;
    }
  } 

  nom = this.fichePatient?.nomUsage || this.fichePatient?.nomNaissance || this.fichePatient?.nom;
  prenom = this.fichePatient?.prenomUsage || this.fichePatient?.prenom;

  if (nom && prenom) {
    const adressePatient: Correspondant = {
      nom,
      prenom,
      adresse1: adressePrincipale,
      codePostal: codePostal,
      ville: ville,
    };
    if (adressePatient.adresse1) {
      Object.defineProperty(adressePatient, 'nom complet', { value: `${nom} ${prenom}` });
      this.correspondantsPatientBodyTable.objects.push(adressePatient);
    } 
  } 
}

// Le correspondant peut etre soit un correspondant soit un contact personnalisé du patient.
selectCorrespondant(event) {
  const cor = event;
  const exists = this.selectBodyTable.objects.some(existingCor => 
    existingCor.id === cor.id );
  if (!exists) {
      this.selectBodyTable.objects.push({
        ...cor,
        nom: cor.prenom ? `${cor.nom} ${cor.prenom}` : cor.nom,
        adresse1: cor.adresse ||cor.adresse1 || "",
        adresse2: cor.adresse2 || "",
        codePostal: cor.codePostal || "",
        ville: cor.ville || ""
      });
  }else {
    this._snakeBarSrv.openSnackBar('Le correspondant a déjà été ajouté.');
  }

}


 deleteCorrespondant(event:Correspondant){
  this.selectBodyTable.objects = this.selectBodyTable.objects.filter(obj => obj.nom !== event.nom);
  this.correspondantsUpdated.emit(this.selectBodyTable.objects); // Emet la suppression du correspondant à edit-courrier
}

public async filterCorrespondants(needle: string): Promise<void> {
  const _normalizeStr = (str: string): string => {
    return this._strUtilsSrv.removeAccents(str).toLowerCase();
  };

  try {
    await this._displayLoading(true); // Afficher le loader

    if (needle && needle.length >= 2) { // on lance la recherche à partir de 2 lettres
      this.correspondantsBodyTable.objects = await this._correspondant.find( {perpage: 0,
        currentPage: 1,
        sortBy: 'nom',
        sortOrder: SortEnum.ASC
      },null, needle);
      this.correspondantsBodyTable.objects = this.correspondantsBodyTable.objects.filter(cor => 
        _normalizeStr(cor.nom).includes(_normalizeStr(needle)) || 
        _normalizeStr(cor.prenom).includes(_normalizeStr(needle))
      );
      for (let co of this.correspondantsBodyTable.objects) {
        Object.defineProperty(co, 'nom complet', { value: co.nom + ' ' + co.prenom });
      }
    } else {
      this.correspondantsBodyTable.objects = [];
    }
  } catch (e) {
    console.error(e);
  } finally {
    await this._displayLoading(false); // On arrête le loader
  }
}


validateCorrespondant(){

    this.correspondantsSelected.emit(this.selectBodyTable.objects);
    this.closeEmitter.emit();
  
}

closeModal() {
  if(this.selectBodyTable.objects.length>0){
    this.selectBodyTable.objects.length=0;
  }
  this.closeEmitter.emit();
}

}
